const TabSection = ({ children, label, ...property }) => {
    return <div>{children}</div>;
};

export default TabSection;
